import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__Text_index_js_276e2960__ from "../../Text/index.js";
import * as __WEBPACK_EXTERNAL_MODULE__AutocompleteListItem_variant_js_dfe2aeff__ from "./AutocompleteListItem.variant.js";
const AutocompleteListItem_AutocompleteListItem = /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react__.forwardRef)(function({ leftNode, firstLine, secondLine, rightNode, isSelected, isHighlighted, isHighlightedIndexWithKeyArrow, ...props }, ref) {
    const { itemWrapperSlot, leftNodeIconWrapperSlot, leftNodeSlot, textSlot, rightNodeSlot } = (0, __WEBPACK_EXTERNAL_MODULE__AutocompleteListItem_variant_js_dfe2aeff__.autocompleteVariants)({
        isSelected,
        isHighlighted,
        isHighlightedIndexWithKeyArrow,
        ...props
    });
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("li", {
        ref: ref,
        className: itemWrapperSlot(),
        ...props,
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: leftNodeIconWrapperSlot(),
                children: [
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                        className: leftNodeSlot(),
                        children: leftNode
                    }),
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: textSlot(),
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Text_index_js_276e2960__.Span, {
                                textStyle: "body2",
                                children: firstLine
                            }),
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__Text_index_js_276e2960__.Span, {
                                textStyle: "body3",
                                children: secondLine
                            })
                        ]
                    })
                ]
            }),
            rightNode && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
                className: rightNodeSlot(),
                children: rightNode
            })
        ]
    });
});
export { AutocompleteListItem_AutocompleteListItem as AutocompleteListItem };
